import React, { useState } from 'react';
import { useLeftSidebarState } from '@atlassian/jira-layout-controller/src/controllers/layout-controller/consumers/left-sidebar-controller/index.tsx';
import { PageLayout } from '@atlassian/jira-navigation-system/src/index.tsx';
import { componentWithFG } from '@atlassian/jira-feature-gate-component';

const PageLayoutWithDefaultSideNavCollapsed = ({
	children,
	...props
}: React.ComponentPropsWithoutRef<typeof PageLayout>) => {
	const { isCollapsed } = useLeftSidebarState();
	const [defaultSideNavCollapsed] = useState(isCollapsed);

	return (
		<PageLayout {...props} defaultSideNavCollapsed={defaultSideNavCollapsed}>
			{children}
		</PageLayout>
	);
};

export const JiraPageLayout = componentWithFG(
	'navx-full-height-sidebar',
	PageLayoutWithDefaultSideNavCollapsed,
	PageLayout,
);
